export const CouponsEndpoint = (makeRequest) => {
    return {
        fetchSignUpConfiguration(params, options) {
            const { coupon_id, ...query } = params;
            return makeRequest('GET', `/v1/billing/coupons/${coupon_id}/sign_up_configuration`, query, options);
        },
    };
};
//# sourceMappingURL=coupons_endpoint.js.map